import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PageService {
    // Video Id Variable
    private videoid = new Subject<any>();
    private _listner = new Subject<any>();
    private category = new Subject<any>();
    private animatoninit = new Subject<any>();
    private reelvideoexit = new Subject<any>();
    private closereelvideo = new Subject<any>();
    private videotiming = new BehaviorSubject(0);
    private workInit = new BehaviorSubject('');
    private _scrollListener = new Subject<any>();
    private _whiteLogo = new Subject<any>();
    private _reel = new Subject<any>();
    private _reelVideo = new Subject<any>();
    private _stopReelVideo = new Subject<any>();
    private _loadPage = new Subject<any>();
    private _rotateRightLogo = new Subject<any>();
    private _rotateLeftLogo = new Subject<any>();
    private _singleWork = new Subject<any>();
    private _reloadedSingle = new Subject<any>();
    private _goToTop = new Subject<any>();
    private _removeSearch = new Subject<any>();
    private _removeSearchHeader = new Subject<any>();
    private _pauseBannerVideo = new Subject<any>();
    private _animateSingle = new Subject<any>();
    private _showGoToTopButton = new Subject<any>();
    private _activateMenuOverlay = new Subject<any>();
    private _stopScroll = new Subject<any>();
    private _mobileVideoPlaying = new Subject<any>();

    callVideoTiming = this.videotiming.asObservable();
    callWorkInit = this.workInit.asObservable();
    constructor() { }

    getQuickViewLink(videoid) {
        this.videoid.next(videoid);
    }


    quickViewComponentActive(): Observable<any> {
        return this.videoid.asObservable();
    }

    listen(): Observable<any> {
        return this._listner.asObservable();
    }

    activeMenu(active: boolean) {
        this._listner.next(active);
    }

    getCategory(category) {
        this.category.next(category);
    }

    returnCategory() {
        return this.category.asObservable();
    }
    getWorkInit(data) {
        this.workInit.next(data)
    }

    reInitAnimation() {
        this.animatoninit.next();
    }

    returnInitAnimation() {
        return this.animatoninit.asObservable();
    }

    reelVideoExit() {
        this.reelvideoexit.next();
    }

    returnReelVideoExit() {
        return this.reelvideoexit.asObservable();
    }
    closeReelVideo() {
        this.closereelvideo.next();
    }

    returnCloseReelVideo() {
        return this.closereelvideo.asObservable();
    }

    setVideoTimer(timing) {
        this.videotiming.next(timing);
    }

    scrollListen(): Observable<any> {
        return this._scrollListener.asObservable();
    }

    scrolled(scrolled: boolean) {
        this._scrollListener.next(scrolled);
    }

    whiteLogoListen(): Observable<any> {
        return this._whiteLogo.asObservable();
    }

    whiteLogo(logo: boolean) {
        this._whiteLogo.next(logo);
    }

    activeReelListen(): Observable<any> {
        return this._reel.asObservable();
    }

    activeReel(reel) {
        this._reel.next(reel);
    }

    activeReelVideoListen(): Observable<any> {
        return this._reelVideo.asObservable();
    }

    activeReelVideo(reel) {
        this._reelVideo.next(reel);
    }

    stopReelVideoListen(): Observable<any> {
        return this._stopReelVideo.asObservable();
    }
    stopReelVideo() {
        this._stopReelVideo.next();
    }

    loadPageListen(): Observable<any> {
        return this._loadPage.asObservable();
    }

    loadPage(text: string) {
        this._loadPage.next(text);
    }


    rotateRightLogoListen(): Observable<any> {
        return this._rotateRightLogo.asObservable();
    }
    rotateRightLogo() {
        this._rotateRightLogo.next();
    }

    rotateLeftLogoListen(): Observable<any> {
        return this._rotateLeftLogo.asObservable();
    }
    rotateLeftLogo() {
        this._rotateLeftLogo.next();
    }

    singleWorkListen(): Observable<any> {
        return this._singleWork.asObservable();
    }
    singleWork(title, subtitle) {
        this._singleWork.next({ title, subtitle });
    }

    worksLoadedListen(): Observable<any> {
        return this._reloadedSingle.asObservable();
    }
    worksLoaded() {
        this._reloadedSingle.next();
    }


    goToTopListen(): Observable<any> {
        return this._goToTop.asObservable();
    }
    goToTop() {
        this._goToTop.next();
    }

    removeSearchListen(): Observable<any> {
        return this._removeSearch.asObservable();
    }
    removeSearch() {
        this._removeSearch.next();
    }

    removeSearchHeaderListen(): Observable<any> {
        return this._removeSearchHeader.asObservable();
    }
    removeSearchHeader() {
        this._removeSearchHeader.next();
    }

    pauseBannerVideoListen(): Observable<any> {
        return this._pauseBannerVideo.asObservable();
    }
    pauseBannerVideo() {
        this._pauseBannerVideo.next();
    }

    animateSingleListen(): Observable<any> {
        return this._animateSingle.asObservable();
    }
    animateSingle() {
        this._animateSingle.next();
    }

    showGoToTopButtonListen(): Observable<any> {
        return this._showGoToTopButton.asObservable();
    }
    showGoToTopButton(show: boolean) {
        this._showGoToTopButton.next(show);
    }

    activateMenuOverlayListen(): Observable<any> {
        return this._activateMenuOverlay.asObservable();
    }
    activateMenuOverlay(show: boolean) {
        this._activateMenuOverlay.next(show);
    }

    stopScrollListen(): Observable<any> {
        return this._stopScroll.asObservable();
    }
    stopScroll(show: boolean) {
        this._stopScroll.next(show);
    }

    mobileVideoPlayingListen(): Observable<any> {
        return this._mobileVideoPlaying.asObservable();
    }
    mobileVideoPlaying(playing: boolean) {
        this._mobileVideoPlaying.next(playing);
    }
}
